import { Controller } from '@hotwired/stimulus';

export default class extends Controller {
  static targets = ['funnelComplete'];

  connect() {
    // Listen for the GTM load event or initialize immediately if GTM is already loaded
    if (window.gtmLoaded) {
      this.initializeDataLayerEvents();
    } else {
      window.addEventListener('gtm:load', () =>
        this.initializeDataLayerEvents()
      );
    }
  }

  initializeDataLayerEvents() {
    if (typeof dataLayer !== 'undefined') {
      dataLayer.push({
        ga4_measurement_id: 'G-MVH0N3CMSH',
      });
    }
    this.sendPageView();
    if (this.hasFunnelCompleteTarget) {
      this.funnelComplete();
      setTimeout(() => {
        this.clearSessionStorage();
      }, 5000);
    }
  }

  clearSessionStorage() {
    sessionStorage.clear();
  }

  sendPageView() {
    /* global dataLayer */
    if (typeof dataLayer !== 'undefined') {
      dataLayer.push({
        event: 'pageview',
        page: {
          path: window.location.pathname,
          title: document.title,
        },
      });
    }
  }

  uetqConsent() {
    // Update UET consent to granted when form is completed
    window.uetq = window.uetq || [];
    window.uetq.push('consent', 'update', {
      'ad_storage': 'granted'
    });
  }

  funnelComplete() {
    // Update consent configuration
    this.uetqConsent();
  
    // Check if dataLayer is available
    if (typeof dataLayer !== 'undefined') {
      // Existing funnelComplete event
      dataLayer.push({
        event: 'funnelComplete',
        email: this.data.get('userEmailValue'),
        phone: this.data.get('userPhoneValue'),
        firstName: this.data.get('userFirstNameValue'),
        lastName: this.data.get('userLastNameValue'),
        zipCode: this.data.get('userZipCodeValue'),
        product: this.data.get('productValue'),
      });
  
      // New sign_up event for TikTok
      dataLayer.push({
        event: 'CompleteRegistration',
        user_data: {
          email_address: this.data.get('userEmailValue'),
          phone_number: this.data.get('userPhoneValue'),
          address: {
            first_name: this.data.get('userFirstNameValue'),
            last_name: this.data.get('userLastNameValue'),
            postal_code: this.data.get('userZipCodeValue'),
          },
        }
      });
    }
  }
}